import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Loader, TextToolTip } from "components";
import { Svg } from "assets";
import { authActions, httpRequestsOnSuccessActions } from "store";
import { FindLoad, FindSuccess, Notify } from "utils";

const ACTION_TYPE = "RESEND_INVITE";

export const ResendInvite = ({ item, showText = false }) => {
  const [currentItem, setCurrentItem] = useState(null);
  const loading = FindLoad(ACTION_TYPE);
  const success = FindSuccess(ACTION_TYPE);
  const dispatch = useDispatch();

  useEffect(() => {
    if (success?.type) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      if (currentItem?.id === item?.id) {
        Notify("Invitation sent successfully.", { type: "success" });
      }
    }
  }, [success]);

  useEffect(() => {
    if (!loading) {
      setCurrentItem(null);
    }
  }, [loading]);

  const handleResendInvite = (e) => {
    e.stopPropagation();
    setCurrentItem(item);
    const sendBody = {
      name: item?.name,
    };

    dispatch(authActions.resendInvite(item?.id, sendBody));
  };

  return (
    <button className="reinvite-button" onClick={handleResendInvite}>
      <div className="reinvite-button-svg-block">
        {!!loading?.length && currentItem?.id === item?.id ? (
          <Loader styles={{ width: "90%", height: "90%", color: "#34A853" }} />
        ) : (
          <TextToolTip
            text={<Svg.ReInviteSvg />}
            content="Reinvite"
            showTooltip={!showText}
            arrow
            placement="right"
          />
        )}
      </div>

      {showText && <p className="reinvite-button-text">Reinvite</p>}
    </button>
  );
};
